// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n9-0";
export var animationContainer = "_n9-1";
export var itemPrice = "_n9-a";
export var itemizedContent = "_n9-9";
export var itemizedHeader = "_n9-7";
export var itemizedRow = "_n9-8";
export var itemizedSection = "_n9-6";
export var modalContent = "_n9-2";
export var orderName = "_n9-3";
export var refundOption = "_n9-4";
export var refundOptionsContainer = "_n9-5";
export var shippingLabel = "_n9-b";
export var totalRow = "_n9-c";